














import { Component, Mixins } from "vue-property-decorator";
import { Point } from "../../../domain/drawing";
import { BrowserKinds, BrowserUtility } from "../../../utilities/BrowserUtility";

@Component
export default class PdfjsViewerContextMenu extends Mixins() {
  data(): any {
    return {
      isVisible: false,
      location: null,
      isCopyable: false,
    };
  }
  isVisible: boolean;
  location: Point;
  isCopyable: boolean;

  get locationStyle(): any {
    return this.location
      ? {
        top: this.location.y + "px",
        left: this.location.x + "px",
      }
      : null;
  }

  handlePointerDowned(event: PointerEvent): void {
    const element = this.toHandleElement(event);
    if (!element) { return; }
    element.setPointerCapture(event.pointerId); // 画面外でボタンを離してもイベントが発生するよう設定
    element.addEventListener("pointerup", this.handlePointerUpped, false);
  }

  private handlePointerUpped(event: PointerEvent): void {
    const element = this.toHandleElement(event);
    if (!element) { return; }
    element.removeEventListener("pointerup", this.handlePointerUpped, false);
    this.location = this.toCurrentLocation(event);
    this.$nextTick(this.updateContextMenu); // 選択範囲が外れる場合があるためメニューの表示は遅延させる
  }

  private toHandleElement(event: PointerEvent): Element {
    if (event.button !== 2 || !event.isPrimary) { return null; }  // 右クリック以外は対象外
    return (event.currentTarget instanceof Element)
      ? event.currentTarget
      : null;
  }

  private toCurrentLocation(event: PointerEvent): Point {
    const element = event.currentTarget;
    if (!(element instanceof Element)) { return null; }
    const clientRect = element.getBoundingClientRect();
    return new Point(
      event.clientX + element.scrollLeft - clientRect.left,
      event.clientY + element.scrollTop - clientRect.top
    );
  }

  private updateContextMenu(): void {
    this.isVisible = !!this.location;
    if (!this.isVisible) { return; }
    const selection = window.getSelection();
    this.isCopyable = !!selection && !selection.isCollapsed;
    document.body.addEventListener("pointerdown", this.onBodyPointerDowned, false);
  }

  private onBodyPointerDowned(event: PointerEvent): void {
    if (!event.isPrimary) { return; }
    const node = event.target;
    if (!(node instanceof Node)) { return; }
    if (this.$el.contains(node)) { return; }
    this.close(); // メニュー以外をクリックしようとした場合、メニューを非表示にする
  }

  private close(): void {
    document.body.removeEventListener("pointerdown", this.onBodyPointerDowned, false);
    this.isVisible = false;
  }

  copy(): void {
    const selection = window.getSelection();
    if (!!selection && !selection.isCollapsed) {
      this.writeTextToClipboard(selection.toString());
    }
    this.close();
  }

  private writeTextToClipboard(data: string): void {
    if (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      ((window as any).clipboardData as DataTransfer).setData("Text", data);
    } else {
      // navigator.permissions.query({name:"clipboard-write"})で判断すべきだが、
      // 現在のTypeScriptバージョンではnameのtypeにclipboard-writeが含まれておらず、anyにキャストしてもFirefoxではサポートされていない模様。
      // そのためclipboardプロパティがあるかどうかで判断している
      if (!!navigator.clipboard) {
        navigator.clipboard.writeText(data);
      } else {
        // localhost以外ではhttps通信ではないとクリップボードにアクセスできないため代用(非推奨)
        document.execCommand("copy");
      }
    }
  }
}
